import styled from 'styled-components';
import {COLORS} from '../../../../values/colors'

export const Container = styled.div`
    text-align: center;
    justify-content: center;
    align-items: center;
    margin-top: 5rem;
    padding-top: 5rem;
    padding-bottom: 5rem;
    @media (max-width: 1050px) {
        padding-top: 3rem;
        margin-top: 2rem;
    }
`;